<script>
    import PermissionCheck from '../../components/PermissionCheck.svelte';
    import Link from '../../router/Link.svelte'
    let permissions = ['STATION.ADD']
</script>
<style>
</style>

<div class="flex flex-row  justify-between border-t-2 border-green-400">
    <Link to={"home"} {...$$props} class="text-green-500   p-3  ">
        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M7.825.12a.5.5 0 00-.65 0L0 6.27v7.23A1.5 1.5 0 001.5 15h4a.5.5 0 00.5-.5v-3a1.5 1.5 0 013 0v3a.5.5 0 00.5.5h4a1.5 1.5 0 001.5-1.5V6.27L7.825.12z" fill="currentColor"></path></svg>
    </Link>    
    <PermissionCheck {permissions}>
        <Link to={"add_station"} {...$$props} class="text-green-500 p-3 border-2">
            <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="23" height="23"><path d="M7.5 1v13M1 7.5h13" stroke="currentColor"></path></svg>
        </Link>    
    </PermissionCheck>
    <Link to={"settings"} {...$$props} class="text-green-500 p-3">
         <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M5 5.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 0a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM1 7.5a6.5 6.5 0 1110.988 4.702A3.5 3.5 0 008.5 9h-2a3.5 3.5 0 00-3.488 3.202A6.482 6.482 0 011 7.5z" fill="currentColor"></path></svg>
    </Link>
</div>